import type { ReactNode } from "react";
import { BrandLogo } from "@dearbill/shared";
import { MemberContactButton } from "./MemberContactButton";
import { PortalFooter } from "./PortalFooter";

/**
 * Page shell for the member portal's signed-out screens: login, OTP entry and
 * the enrollment-flow handoff. The signed-in Home uses `MemberLayout` instead.
 * `session` is threaded in (not read via `usePortalSession` here) because a
 * second call to that hook would get an independent, non-reactive snapshot;
 * the routes that render the shell already hold the reactive session.
 */
export function PortalShell({
  children,
  session,
}: {
  children: ReactNode;
  session?: string | null;
}): ReactNode {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <div className="border-haze flex items-center justify-between gap-4 border-b bg-white px-8 py-4">
        <div className="flex items-center gap-3">
          <BrandLogo className="h-6" />
          <span className="text-slate-teal text-sm font-semibold">Member</span>
        </div>
        <div className="flex items-center gap-4">
          <MemberContactButton session={session} />
        </div>
      </div>
      <main className="mx-auto w-full max-w-2xl flex-1 px-6 py-10">{children}</main>
      {/* Outside `<main>` so it is a `contentinfo` landmark. */}
      <PortalFooter />
    </div>
  );
}
